import {
  type Slot,
  type SlotConfig,
} from "@voxmedia/duet-context/context/config-context";
import { styles } from "@voxmedia/duet-ui/components/ad/Ad";

const ARTICLE_SPONSORSHIP_DESKTOP_CONFIG: SlotConfig = {
  ...styles.articleSponsorshipConfig,
  viewport: "desktop",
};

const ARTICLE_SPONSORSHIP_MOBILE_AND_TABLET_CONFIG: SlotConfig = {
  ...styles.articleSponsorshipMobileConfig,
  viewport: "mobileAndTablet",
};

const ARTICLE_SPONSORSHIP_HEADLINE_ABOVE_DESKTOP_CONFIG: SlotConfig = {
  ...styles.articleSponsorshipHeadlineAboveDesktopConfig,
  viewport: "desktop",
};

const ATHENA_GAMES_HUB_TABLET_AND_DESKTOP_CONFIG: SlotConfig = {
  ...styles.athenaGamesHubTabletAndDesktopConfig,
  viewport: "tabletAndDesktop",
};

const ATHENA_GAMES_HUB_MOBILE_CONFIG: SlotConfig = {
  ...styles.athenaGamesHubMobileConfig,
  viewport: "mobile",
};

const FRONTPAGE_SECONDARY_MOBILE: SlotConfig = {
  ...styles.frontpageSecondaryMobileConfig,
  viewport: "mobile",
};

const FRONTPAGE_HERO_MOBILE: SlotConfig = {
  ...styles.frontpageHeroMobileConfig,
  viewport: "mobile",
};

const FRONTPAGE_HERO_DESKTOP: SlotConfig = {
  ...styles.frontpageHeroDesktopConfig,
  viewport: "desktop",
};

const FRONTPAGE_HERO_TABLET: SlotConfig = {
  ...styles.frontpageHeroTabletConfig,
  viewport: "tablet",
};

const LEADERBOARD_TOP_TABLET_DESKTOP_CONFIG: SlotConfig = {
  ...styles.leaderboardTopTabletDesktopConfig,
  viewport: "flexTabletAndDesktop",
};

const MEDIUM_RECTANGLE_HERO_CONFIG: SlotConfig = {
  viewport: "desktop",
};

const MEDREC_FRONTPAGE_HERO__MOBILE_CONFIG: SlotConfig = {
  ...styles.medrecFrontpageHeroMobileConfig,
  viewport: "mobile",
};

const LEADERBOARD_MOBILE_CONFIG: SlotConfig = {
  ...styles.leaderboardMobileConfig,
  viewport: "mobile",
};

const LEADERBOARD_TABLET_CONFIG: SlotConfig = {
  ...styles.leaderboardTabletConfig,
  viewport: "tablet",
};

const LEADERBOARD_DESKTOP_CONFIG: SlotConfig = {
  ...styles.leaderboardDesktopConfig,
  viewport: "desktop",
};

const PACKAGE_SPONSORSHIP_CONFIG: SlotConfig = {
  ...styles.articleSponsorshipConfig,
  viewport: "all",
};

const PACKAGE_LEADERBOARD_DESKTOP_CONFIG: SlotConfig = {
  ...styles.packageLeaderboardDesktopConfig,
  viewport: "desktop",
};

const STREAM_LEADERBOARD_TABLET_CONFIG: SlotConfig = {
  ...styles.streamLeaderboardTabletConfig,
  viewport: "tablet",
};

const STREAM_LEADERBOARD_DESKTOP_CONFIG: SlotConfig = {
  ...styles.streamLeaderboardDesktopConfig,
  viewport: "desktop",
};

const NETWORK_RIVER_MOBILE_TOP_CONFIG: SlotConfig = {
  ...styles.networkRiverMobileTopConfig,
  viewport: "mobile",
};

const NETWORK_RIVER_MOBILE_CONFIG: SlotConfig = {
  ...styles.networkRiverMobileConfig,
  viewport: "mobile",
};

const NETWORK_RIVER_TABLET_TOP_CONFIG: SlotConfig = {
  ...styles.networkRiverTabletTopConfig,
  viewport: "tablet",
};

const NETWORK_RIVER_TABLET_CONFIG: SlotConfig = {
  ...styles.networkRiverTabletConfig,
  viewport: "tablet",
};

const NETWORK_RIVER_TABLET_HOME_CONFIG: SlotConfig = {
  ...styles.networkRiverTabletHomeConfig,
  viewport: "tablet",
};

const NETWORK_RIVER_DESKTOP_TOP_CONFIG: SlotConfig = {
  ...styles.networkRiverDesktopTopConfig,
  viewport: "desktop",
};

const NETWORK_RIVER_DESKTOP_CONFIG: SlotConfig = {
  ...styles.networkRiverDesktopConfig,
  viewport: "desktop",
};

const NETWORK_RIVER_DESKTOP_HOMEPAGE_CONFIG: SlotConfig = {
  ...styles.networkRiverDesktopHomepageConfig,
  viewport: "desktop",
};

const RIGHT_RAIL_NETWORK_RIVER_DESKTOP_CONFIG: SlotConfig = {
  ...styles.rightRailNetworkRiverDesktopConfig,
  viewport: "desktop",
};

const RIGHT_RAIL_NETWORK_RIVER_ABOVE_NEWSLETTER_DESKTOP_CONFIG: SlotConfig = {
  ...styles.rightRailNetworkRiverAboveNewsletterDesktopConfig,
  viewport: "desktop",
};

const RIGHT_RAIL_NETWORK_RIVER_INLINE_DESKTOP_CONFIG: SlotConfig = {
  ...styles.rightRailNetworkRiverAboveNewsletterDesktopConfig,
  viewport: "desktop",
};

const TOP_RIGHT_RAIL_HUB_DESKTOP_CONFIG: SlotConfig = {
  ...styles.topRightRailHubDesktopConfig,
  viewport: "desktop",
};

const RIGHT_RAIL_COMMENTS_DESKTOP_CONFIG: SlotConfig = {
  ...styles.rightRailCommentsDesktopConfig,
  viewport: "desktop",
};

const RIGHT_RAIL_HOME_DESKTOP_CONFIG: SlotConfig = {
  ...styles.rightRailHomeDesktopConfig,
  viewport: "desktop",
};

const TOP_RIGHT_RAIL_ARTICLE_DESKTOP_CONFIG: SlotConfig = {
  ...styles.topRightRailArticleDesktopConfig,
  viewport: "desktop",
};

const BOTTOM_RIGHT_RAIL_HUB_DESKTOP_CONFIG: SlotConfig = {
  ...styles.bottomRightRailHubDesktopConfig,
  viewport: "desktop",
};

const BOTTOM_RIGHT_RAIL_ARTICLE_DESKTOP_CONFIG: SlotConfig = {
  ...styles.bottomRightRailArticleDesktopConfig,
  viewport: "desktop",
};

const CONNATIX_RIGHT_RAIL: SlotConfig = {
  ...styles.connatixRightRailConfig,
  viewport: "desktop",
};

const SPECIAL_SPONSORSHIP_MOBILE_AND_TABLET: SlotConfig = {
  ...styles.specialSponsorshipMobileAndTabletConfig,
  viewport: "mobileAndTablet",
};

const SPECIAL_SPONSORSHIP_DESKTOP: SlotConfig = {
  ...styles.specialSponsorshipDesktopConfig,
  viewport: "desktop",
};

const FEATURE_EXTENDED_STICKY: SlotConfig = {
  ...styles.featureExtendedStickyConfig,
  viewport: "desktop",
};

const HUB_SPONSORSHIP: SlotConfig = {
  ...styles.hubSponsorshipConfig,
  viewport: "all",
};

export const staticAdConfig: Record<string, ReadonlyArray<Slot>> = {
  articleSponsorshipMobileAndTablet: [
    {
      slotName: "article_sponsorship_mobile_and_tablet",
      ...ARTICLE_SPONSORSHIP_MOBILE_AND_TABLET_CONFIG,
    },
  ],
  articleSponsorshipDesktop: [
    {
      slotName: "article_sponsorship_desktop",
      ...ARTICLE_SPONSORSHIP_DESKTOP_CONFIG,
    },
  ],
  articleSponsorshipHeadlineAboveMobileAndTablet: [
    {
      slotName: "article_sponsorship_headline_above_mobile_and_tablet",
      ...ARTICLE_SPONSORSHIP_MOBILE_AND_TABLET_CONFIG,
    },
  ],
  articleSponsorshipHeadlineAboveDesktop: [
    {
      slotName: "article_sponsorship_headline_above_desktop",
      ...ARTICLE_SPONSORSHIP_HEADLINE_ABOVE_DESKTOP_CONFIG,
    },
  ],
  articleSponsorshipWhiteMobileAndTablet: [
    {
      slotName: "article_sponsorship_white_mobile_and_tablet",
      ...ARTICLE_SPONSORSHIP_MOBILE_AND_TABLET_CONFIG,
    },
  ],
  articleSponsorshipWhiteDesktop: [
    {
      slotName: "article_sponsorship_white_desktop",
      ...ARTICLE_SPONSORSHIP_HEADLINE_ABOVE_DESKTOP_CONFIG,
    },
  ],
  articleStreamSponsorship: [
    {
      slotName: "article_sponsorship_desktop",
      ...ARTICLE_SPONSORSHIP_DESKTOP_CONFIG,
    },
    {
      slotName: "article_sponsorship_headline_above_mobile_and_tablet",
      ...ARTICLE_SPONSORSHIP_MOBILE_AND_TABLET_CONFIG,
    },
  ],
  articleStreamSponsorshipWhite: [
    {
      slotName: "article_sponsorship_white_desktop",
      ...ARTICLE_SPONSORSHIP_DESKTOP_CONFIG,
    },
    {
      slotName: "article_sponsorship_headline_above_mobile_and_tablet",
      ...ARTICLE_SPONSORSHIP_MOBILE_AND_TABLET_CONFIG,
    },
  ],
  in5Sponsorship: [
    {
      slotName: "article_sponsorship_desktop",
      ...ARTICLE_SPONSORSHIP_DESKTOP_CONFIG,
    },
    {
      slotName: "article_sponsorship_mobile_and_tablet",
      ...ARTICLE_SPONSORSHIP_MOBILE_AND_TABLET_CONFIG,
    },
  ],
  athenaGamesHub: [
    {
      slotName: "athena_games_hub_mobile",
      ...ATHENA_GAMES_HUB_MOBILE_CONFIG,
    },
    {
      slotName: "athena_games_hub_desktop_tablet",
      ...ATHENA_GAMES_HUB_TABLET_AND_DESKTOP_CONFIG,
    },
  ],
  connatixRightRail: [
    {
      slotName: "connatix_right_rail",
      ...CONNATIX_RIGHT_RAIL,
      hideIfSubscription: ["verge"],
    },
  ],
  frontpageSecondaryMobile: [
    {
      slotName: "frontpage_secondary_mobile",
      ...FRONTPAGE_SECONDARY_MOBILE,
    },
  ],
  frontpageHeroMobile: [
    {
      slotName: "frontpage_hero_mobile",
      ...FRONTPAGE_HERO_MOBILE,
    },
  ],
  frontpageHeroDesktop: [
    {
      slotName: "frontpage_hero_desktop",
      ...FRONTPAGE_HERO_DESKTOP,
    },
  ],
  frontpageHeroTablet: [
    {
      slotName: "frontpage_hero_tablet",
      ...FRONTPAGE_HERO_TABLET,
    },
  ],
  networkRiverHomeTop: [
    {
      slotName: "mobile_network_river",
      ...NETWORK_RIVER_MOBILE_TOP_CONFIG,
    },
    {
      slotName: "tablet_network_river",
      ...NETWORK_RIVER_TABLET_TOP_CONFIG,
    },
    {
      slotName: "desktop_network_river",
      ...NETWORK_RIVER_DESKTOP_TOP_CONFIG,
    },
  ],
  networkRiverHome: [
    {
      slotName: "mobile_network_river",
      ...NETWORK_RIVER_MOBILE_CONFIG,
    },
    {
      slotName: "tablet_network_river",
      ...NETWORK_RIVER_TABLET_CONFIG,
    },
    {
      slotName: "desktop_network_river",
      ...NETWORK_RIVER_DESKTOP_CONFIG,
    },
  ],
  mobileTabletNetworkRiverHome: [
    {
      slotName: "mobile_network_river",
      ...NETWORK_RIVER_MOBILE_CONFIG,
    },
    {
      slotName: "tablet_network_river",
      ...NETWORK_RIVER_TABLET_HOME_CONFIG,
    },
  ],
  desktopTopstoriesRiverHome: [
    {
      slotName: "desktop_topstories_river",
      ...NETWORK_RIVER_DESKTOP_HOMEPAGE_CONFIG,
    },
  ],
  desktopNetworkRiverHome: [
    {
      slotName: "desktop_network_river",
      ...NETWORK_RIVER_DESKTOP_CONFIG,
    },
  ],
  networkRiverArticle: [
    {
      slotName: "mobile_network_river",
      ...NETWORK_RIVER_MOBILE_CONFIG,
    },
    {
      slotName: "tablet_network_river",
      ...NETWORK_RIVER_TABLET_CONFIG,
    },
  ],
  packageSponsorship: [
    {
      slotName: "package_sponsorship",
      ...PACKAGE_SPONSORSHIP_CONFIG,
    },
  ],
  rightRailNetworkRiver: [
    {
      slotName: "medium_rectangle_river",
      ...RIGHT_RAIL_NETWORK_RIVER_DESKTOP_CONFIG,
    },
  ],
  rightRailNetworkRiverAboveNewsletter: [
    {
      slotName: "medium_rectangle_river",
      ...RIGHT_RAIL_NETWORK_RIVER_ABOVE_NEWSLETTER_DESKTOP_CONFIG,
    },
  ],
  rightRailNetworkRiverInline: [
    {
      slotName: "medium_rectangle_river",
      ...RIGHT_RAIL_NETWORK_RIVER_INLINE_DESKTOP_CONFIG,
    },
  ],
  leaderboardArticle: [
    {
      slotName: "tablet_leaderboard",
      ...LEADERBOARD_TABLET_CONFIG,
    },
    {
      slotName: "desktop_leaderboard_variable",
      ...LEADERBOARD_DESKTOP_CONFIG,
    },
  ],
  leaderboardAuthor: [
    {
      slotName: "tablet_leaderboard",
      ...LEADERBOARD_TABLET_CONFIG,
    },
    {
      slotName: "desktop_leaderboard_variable",
      ...LEADERBOARD_DESKTOP_CONFIG,
    },
  ],
  leaderboardHub: [
    {
      slotName: "mobile_leaderboard",
      ...LEADERBOARD_MOBILE_CONFIG,
    },
    {
      slotName: "tablet_leaderboard",
      ...LEADERBOARD_TABLET_CONFIG,
    },
    {
      slotName: "desktop_leaderboard_variable",
      ...LEADERBOARD_DESKTOP_CONFIG,
    },
  ],
  leaderboardPackagedHub: [
    {
      slotName: "tablet_leaderboard",
      ...LEADERBOARD_TABLET_CONFIG,
    },
    {
      slotName: "desktop_leaderboard_variable",
      ...PACKAGE_LEADERBOARD_DESKTOP_CONFIG,
    },
  ],
  leaderboardStream: [
    {
      slotName: "storystream_top_leaderboard_tablet",
      ...STREAM_LEADERBOARD_TABLET_CONFIG,
    },
    {
      slotName: "storystream_top_leaderboard_desktop",
      ...STREAM_LEADERBOARD_DESKTOP_CONFIG,
    },
  ],
  leaderboardTop: [
    {
      slotName: "leaderboard_top_tablet_desktop",
      ...LEADERBOARD_TOP_TABLET_DESKTOP_CONFIG,
      hideIfSubscription: ["verge"],
    },
  ],
  mediumRectangleHero: [
    {
      slotName: "medium_rectangle_hero",
      ...MEDIUM_RECTANGLE_HERO_CONFIG,
    },
  ],
  medrecFrontpageHero: [
    {
      slotName: "medrec_frontpage_hero_mobile",
      ...MEDREC_FRONTPAGE_HERO__MOBILE_CONFIG,
    },
  ],
  commentsRightRail: [
    {
      slotName: "comments_medium_rectangle",
      ...RIGHT_RAIL_COMMENTS_DESKTOP_CONFIG,
    },
  ],
  topRightRailHub: [
    {
      slotName: "medium_rectangle_variable",
      ...TOP_RIGHT_RAIL_HUB_DESKTOP_CONFIG,
    },
  ],
  topRightRailHome: [
    {
      slotName: "medium_rectangle_variable_home",
      ...RIGHT_RAIL_HOME_DESKTOP_CONFIG,
    },
  ],
  topRightRailArticle: [
    {
      slotName: "medium_rectangle_variable",
      ...TOP_RIGHT_RAIL_ARTICLE_DESKTOP_CONFIG,
    },
  ],
  bottomRightRail: [
    {
      slotName: "btf_medium_rectangle_variable",
      ...BOTTOM_RIGHT_RAIL_HUB_DESKTOP_CONFIG,
      hideIfSubscription: ["verge"],
    },
  ],
  bottomRightRailHome: [
    {
      slotName: "btf_medium_rectangle_variable_home",
      ...RIGHT_RAIL_HOME_DESKTOP_CONFIG,
    },
  ],
  bottomRightRailHub: [
    {
      slotName: "btf_medium_rectangle_variable_hub",
      ...BOTTOM_RIGHT_RAIL_HUB_DESKTOP_CONFIG,
      hideIfSubscription: ["verge"],
    },
  ],
  bottomRightRailArticle: [
    {
      slotName: "btf_medium_rectangle_variable_article",
      ...BOTTOM_RIGHT_RAIL_ARTICLE_DESKTOP_CONFIG,
      hideIfSubscription: ["verge"],
    },
  ],

  specialSponsorshipRail: [
    {
      slotName: "medium_rectangle_gamestop_desktop",
      ...SPECIAL_SPONSORSHIP_DESKTOP,
    },
  ],

  specialSponsorshipBody: [
    {
      slotName: "medium_rectangle_gamestop_mobile_and_tablet",
      ...SPECIAL_SPONSORSHIP_MOBILE_AND_TABLET,
      hideIfSubscription: ["verge"],
    },
  ],
  featureExtendedSticky: [
    {
      slotName: "btf_medium_rectangle_variable_feature_extended_sticky",
      ...FEATURE_EXTENDED_STICKY,
    },
  ],

  hubSponsorship: [
    {
      slotName: "hub_sponsorship",
      ...HUB_SPONSORSHIP,
    },
  ],
  leaderboardStreamWordpress: [
    {
      slotName: "mobile_leaderboard",
      ...LEADERBOARD_MOBILE_CONFIG,
    },
    {
      slotName: "tablet_leaderboard",
      ...LEADERBOARD_TABLET_CONFIG,
    },
    {
      slotName: "desktop_leaderboard_variable",
      ...STREAM_LEADERBOARD_DESKTOP_CONFIG,
    },
  ],
  leaderboardVideoGameWordpress: [
    {
      slotName: "mobile_leaderboard",
      ...LEADERBOARD_MOBILE_CONFIG,
    },
    {
      slotName: "tablet_leaderboard",
      ...LEADERBOARD_TABLET_CONFIG,
    },
    {
      slotName: "desktop_leaderboard_variable",
      ...STREAM_LEADERBOARD_DESKTOP_CONFIG,
    },
  ],
  leaderboardArticleWordpress: [
    {
      slotName: "mobile_leaderboard",
      ...LEADERBOARD_MOBILE_CONFIG,
    },
    {
      slotName: "tablet_leaderboard",
      ...LEADERBOARD_TABLET_CONFIG,
    },
    {
      slotName: "desktop_leaderboard_variable",
      ...LEADERBOARD_DESKTOP_CONFIG,
    },
  ],
  leaderboardAuthorWordpress: [
    {
      slotName: "mobile_leaderboard",
      ...LEADERBOARD_MOBILE_CONFIG,
    },
    {
      slotName: "tablet_leaderboard",
      ...LEADERBOARD_TABLET_CONFIG,
    },
    {
      slotName: "desktop_leaderboard_variable",
      ...LEADERBOARD_DESKTOP_CONFIG,
    },
  ],
};
